import O1HD from "../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;
/**
 * 内容Item
 */
@ccclass
export default class LocalMagicContentItem extends cc.Component {

    @property(cc.Node)
    contentItem : cc.Node = null;
    @property(cc.Node)
    label: cc.Node = null;
    @property(cc.Node)
    pointLbNode : cc.Node = null;

    private mStr : string;
    private mIndex : number = 1;

    onLoad () {}

    start () {

    }

    bindData( content : string ,callBack ,intervalSecond : number = 0.1 ){
        this.mIndex = 1;
        this.mStr = content;
        this.setLbContent( callBack , intervalSecond );
    }

    pointNodeArray : cc.Node[] = [];

    //设置内容
    setLbContent( callBack , intervalSecond : number = 0.1 ){
        if ( this.mIndex <= this.mStr.length ){
            O1HD.getManagers().soundMgr.playSound("keyBoard", null, BUNDLE_SMALL_NAME.localMagic).then();
            let wordNode : cc.Node = cc.instantiate( this.label );
            wordNode.active = true;
            // console.log("this.mIndex",this.mIndex,`${this.mStr.substr(this.mIndex-1,1)}`);
            wordNode.getComponent(cc.Label).string = `${this.mStr.substr(this.mIndex-1,1)}`;
            this.contentItem.addChild( wordNode );
            if ( this.mStr.substr(this.mIndex-1,1) == "." ) {
                let wordNode2 : cc.Node = cc.instantiate( this.label );
                wordNode2.active = true;
                wordNode2.getComponent(cc.Label).string = `${this.mStr.substr(this.mIndex-1,1)}`;
                this.contentItem.addChild( wordNode2 );
                let wordNode3 : cc.Node = cc.instantiate( this.label );
                wordNode3.active = true;
                wordNode3.getComponent(cc.Label).string = `${this.mStr.substr(this.mIndex-1,1)}`;
                this.contentItem.addChild( wordNode3 );

                this.pointNodeArray.push(wordNode);
                this.pointNodeArray.push(wordNode2);
                this.pointNodeArray.push(wordNode3);

                //开启效果
                this._addPointLb( wordNode );
                this.scheduleOnce( ()=>{this._addPointLb( wordNode2 )},0.25 );
                this.scheduleOnce( ()=>{this._addPointLb( wordNode3 )},0.4 );
                this.scheduleOnce( ()=>{
                    for ( let pointNode of this.pointNodeArray ) {
                        pointNode.active = false;
                    }
                    this.pointNodeArray = [];
                    callBack && callBack();
                },1.5 );
            }else{
                this.mIndex++;
                this.scheduleOnce(()=>{
                    this.setLbContent( callBack );
                },intervalSecond );
            }
        }else{
            //加载下一个
            callBack && callBack();
        }
    }

    //添加lb
    private _addPointLb( pointNode : cc.Node ){
        cc.tween( pointNode )
            .by(0.5,{ y : 20 } )
            .by(0.5,{y : -20 })
            .by(0.5,{ y : 20 } )
            .by(0.5,{y : -20 })
            .start();
    }

}
